import { useLocation } from 'wouter'
import { useTheme } from '../../theme'
import { useAuth } from '../../AuthContext'
import RinaContextCard from '../../components/RinaContextCard'
import PageHub from '../../components/PageHub'
import AuthMethodsSection from './AuthMethodsSection'
import { classeChamp } from './champs'
import { ROUTES } from '../../routes'

/** Page « Securite & connexion » (S56) : une vraie Route (/account/securite). */
export default function PageSecurite() {
  const [, setLocation] = useLocation()
  const { isWeb3 } = useTheme()
  const { user } = useAuth()
  const hasPinAuth = user?.telephone && user?.email?.endsWith('@phone.manrina.local')
  return (
    <PageHub retour={{ label: 'Compte', vers: ROUTES.compte.base }}>
      <div className="animate-fade-up">
        <RinaContextCard title="Sécurité & connexion" message="Votre code PIN et vos méthodes de connexion se gèrent ici." />
        {/* Arbitrage Enzo (S34) : la page ne porte QUE les methodes de connexion
            tant qu'on n'en propose pas d'autre. « Changer mon PIN » est l'action
            de la ligne « Téléphone + PIN », la seule methode ouverte. */}
        <AuthMethodsSection tc="text-ink" ts="text-ink/60" cardBg="bg-card border-card-border"
          inputCls={classeChamp(isWeb3)}
          onChangerPin={hasPinAuth ? () => setLocation(ROUTES.compte.pin) : null} />
      </div>
    </PageHub>
  )
}
